import { render, staticRenderFns } from "./admin-user-detail.vue?vue&type=template&id=77fc6352&scoped=true&"
import script from "./admin-user-detail.vue?vue&type=script&lang=js&"
export * from "./admin-user-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc6352",
  null
  
)

export default component.exports